// extracted by mini-css-extract-plugin
export default {"fullpage-container":"fullpage_fullpage-container__k8pvX"};